module.exports = require('./helpers/bundle-url').getBundleURL('hn8mh') + "givingTuesdayLogo.67a2e257.svg";